/* eslint-disable camelcase */
/* eslint-disable no-case-declarations */
import axios from 'axios';
import { delay } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getMRCartFromShopifyCart,
  isPresentInCart,
  refreshAJAXCart,
} from '../../../../common/cart';
import { goToCart } from '../../../../common/navigation';
import { getShop, isCartPage } from '../../../../common/pageData';
import { setOpenDrawer } from '../../../../common/settings';
import { _getVariantQuantityFromCart } from '../../../../productHelper';
import { StaticMutexKeys, mutexManager } from '../../../../common/mutexmanager';

import {
  ADD_TO_CART_SUCCESS,
  FETCH_CART_API,
  ADD_TO_CART_API,
  ADD_PRIMARY_TO_CART_SUCCESS,
  SET_ATC_STATUS_ADDED,
  RESET_ATC_STATUS,
  ADDED_ATC_STATUS_HIDE_DELAY,
} from '../constants';
import { logger } from '../../../../common/logger';
import { reloadPage } from '../../../../pageHelper';

function* addPrimaryToCartWorker(action) {
  // as parallel modification of cart results in inconsistent data, adding mutex
  const shopifyCartMutex = mutexManager.getMutex(StaticMutexKeys.CART_MODIFY);
  try {
    yield call([shopifyCartMutex, 'acquire']);
    const {
      datapack: {
        primary,
        isProductPage,
        isEmbedded,
        variantsWithQuantity,
        variant_id,
        theme,
        offerType,
        widgetID,
      },
    } = action;

    if (!isProductPage) {
      yield call(changeATCStatus, variant_id, widgetID);

      if (theme.isProductButtonActionGoToCart && !isEmbedded) {
        goToCart({
          isPopup: !isEmbedded,
          isRefreshPageAfterProductAddition: true,
        });
        return;
      }

      // reload page for this shop
      if (
        (offerType === 'crossell' || offerType === 'freegift') &&
        theme.isRefreshPageAfterProductAddition &&
        isEmbedded
      ) {
        if (!isCartPage()) {
          setOpenDrawer('true');
        }
        logger.log('refresh initiated line 66');
        reloadPage();
      }
      refreshAJAXCart();

      if (getShop() === 'thelagaadi.myshopify.com') {
        // TODO: fix this
        // eslint-disable-next-line import/no-cycle
        const shopEventModule = yield import('../../../../features/shopEventModule');
        shopEventModule.clickCheckout();
      }
      return;
    }

    // for fbt primary is not sent on successfull addition so handle
    if (!primary) {
      refreshAJAXCart();
      return;
    }

    if (offerType === 'vd') refreshAJAXCart();

    const httpCartArgs = [FETCH_CART_API];
    const { data: cart } = yield call(axios.get, ...httpCartArgs);
    const isOfferedAlsoPrimary = variant_id === primary.sp_variant_id;
    let minimumPrimaryPresent = true;
    if (isOfferedAlsoPrimary) {
      const mrCart = getMRCartFromShopifyCart(cart);
      const primaryQuantity = _getVariantQuantityFromCart(mrCart, variant_id);
      minimumPrimaryPresent = primaryQuantity > 1;
    }

    const isSkipPrimaryAddition = [
      'appointed.myshopify.com',
      'dr-ashley.myshopify.com',
    ].includes(getShop());

    if (
      (isPresentInCart(primary.sp_product_id, primary.sp_variant_id, cart) &&
        minimumPrimaryPresent) ||
      isSkipPrimaryAddition
    ) {
      if (['little-sky-stone.myshopify.com'].includes(getShop())) {
        reloadPage();
      }

      yield call(changeATCStatus, variant_id, widgetID);

      if (theme.isProductButtonActionGoToCart) {
        const isRefresh =
          !isEmbedded || theme.isRefreshPageAfterProductAddition;
        goToCart({
          isPopup: !isEmbedded,
          isRefreshPageAfterProductAddition: isRefresh,
        });
        if (isRefresh) {
          return;
        }
      }

      if (
        (offerType === 'crossell' || offerType === 'freegift') &&
        theme.isRefreshPageAfterProductAddition &&
        isEmbedded
      ) {
        logger.log('refresh initiated line 128');
        reloadPage();
      }
      refreshAJAXCart();
      return;
    }

    const req = {};
    for (let i = 0; i < variantsWithQuantity.length; i += 1) {
      const item = variantsWithQuantity[i];
      if (item.sp_variant_id === primary.sp_variant_id) {
        req.id = item.sp_variant_id;
        if (item.properties) {
          req.properties = item.properties;
        }
        req.quantity = 1;
      }
    }

    const httpArgs = [ADD_TO_CART_API, req];
    const { data: primaryAddition } = yield call(axios.post, ...httpArgs);

    yield put({
      type: ADD_PRIMARY_TO_CART_SUCCESS,
      datapack: {
        ...primaryAddition,
        widgetID,
      },
    });

    // Temporary klaviyo events for  aletha health
    if (window.klaviyo && window.klaviyo.push) {
      logger.log('klaviyo push');
      const resp = window.klaviyo.push([
        'track',
        'Added to Cart',
        { AddedItemProductID: primary.sp_product_id.toString() },
      ]);
      logger.log('klaviyo push response', resp);
    }

    if (['little-sky-stone.myshopify.com'].includes(getShop())) {
      reloadPage();
    }

    yield call(changeATCStatus, variant_id, widgetID);

    if (theme.isProductButtonActionGoToCart) {
      const isRefresh = !isEmbedded || theme.isRefreshPageAfterProductAddition;
      goToCart({
        isPopup: !isEmbedded,
        isRefreshPageAfterProductAddition: isRefresh,
      });
      if (isRefresh) {
        return;
      }
    }

    if (
      (offerType === 'crossell' || offerType === 'freegift') &&
      theme.isRefreshPageAfterProductAddition &&
      isEmbedded
    ) {
      logger.log('refresh initiated line 191');
      reloadPage();
    }
    refreshAJAXCart();
  } catch (e) {
    logger.log(e);
  } finally {
    shopifyCartMutex.release();
  }
}

export default function* addPrimaryToCartWatcher() {
  yield takeEvery([ADD_TO_CART_SUCCESS], addPrimaryToCartWorker);
}

export function* changeATCStatus(variant_id, widgetID) {
  yield put({
    type: SET_ATC_STATUS_ADDED,
    ...{
      spVariantID: variant_id,
      widgetID,
    },
  });
  yield delay(ADDED_ATC_STATUS_HIDE_DELAY);
  yield put({
    type: RESET_ATC_STATUS,
    ...{
      spVariantID: variant_id,
      widgetID,
    },
  });
}
